module.exports = __webpack_public_path__ + "img/our-story.559b74f4.jpg";